export const StepTypes = {
  CHANNEL_MAPPING: 'channel_mapping',
  UTM_MAPPING: 'utm_mapping',
  REFERRER_MAPPING: 'referrer_mapping',
  CUSTOM_MAPPING: 'custom_mapping',
  ANALYTICS_EXPLORER: 'analytics_explorer',
  INTERNAL_WHITELISTING: 'internal_whitelisting',
  COUNTRY_FILTER: 'country_filter',
  DATA_COLLECTION: 'data_collection'
}

const steps = [
  {
    id: 1,
    step: StepTypes.CHANNEL_MAPPING,
    title: 'Channel Mapping',
    status: '',
    description:
      'Please confirm that all the channels that you are using exist. If you need to add new channels, please reach out to us.'
  },
  {
    id: 2,
    step: StepTypes.UTM_MAPPING,
    title: 'UTM Mapping',
    status: '',
    description:
      'Please confirm that all the relevant examples of URLs are mapped to corresponding traffic sources.'
  },
  {
    id: 3,
    step: StepTypes.REFERRER_MAPPING,
    title: 'Referrer Mapping',
    status: '',
    description:
      'Please confirm that all the relevant examples of URLs are mapped to corresponding traffic sources.'
  },
  {
    id: 4,
    step: StepTypes.CUSTOM_MAPPING,
    title: 'Custom Mapping',
    status: '',
    description:
      'Please confirm that all the relevant examples of URLs are mapped to corresponding traffic sources.'
  },
  {
    id: 5,
    step: StepTypes.ANALYTICS_EXPLORER,
    title: 'Analytics Explorer',
    status: '',
    description:
      'Check that you are seeing the matching of sessions from channels compared to clicks in advertising platforms to validate tracking implementation.'
  },
  {
    id: 6,
    step: StepTypes.INTERNAL_WHITELISTING,
    title: 'Internal Whitelisting',
    status: '',
    description:
      'In this section you can list all internal domains and subdomains as well as all 3rd party domains that should not result in a new session.'
  },
  {
    id: 7,
    step: StepTypes.COUNTRY_FILTER,
    title: 'Country Filter',
    status: '',
    description:
      'Confirm that you are happy to proceed with the current settings for the country filter (applied across platform).'
  },
  {
    id: 8,
    step: StepTypes.DATA_COLLECTION,
    title: 'Data Collection',
    status: '',
    description:
      'Confirm that the number of conversions of both types and impressions match the other platforms.'
  }
]

export default steps



// WEBPACK FOOTER //
// ./client/redux/modules/onboard/steps.js